/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { AttachmentDto } from '../../models/attachment-dto';
import { UploadRequestDto } from '../../models/upload-request-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface Save$Params {
  keepBookingState?: boolean;
  body?: UploadRequestDto;
}

export function save(
  http: HttpClient,
  rootUrl: string,
  params?: Save$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<AttachmentDto>>> {
  const rb = new RequestBuilder(rootUrl, save.PATH, 'post');
  if (params) {
    rb.query('keepBookingState', params.keepBookingState, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AttachmentDto>>;
    }),
  );
}

save.PATH = '/service/v1/attachment/file';
